import WebLayout from './ChatWidgetLayout.web';
import { isReactNative } from 'ui-builder';

function MobilePlaceholder() {
  return null;
}

export default isReactNative() ? MobilePlaceholder : WebLayout;
